document.addEventListener("DOMContentLoaded", function () {
  fetch("https://danshepardmadeit-ig-feed.shepard-danielj.workers.dev/")
    .then(res => res.json())
    .then(response => {
      const container = document.getElementById("instagram-feed");
      if (!container) return;

      const posts = response.data;
      const grid = document.createElement("div");
      grid.className = "ig-grid";

      posts.slice(0, 12).forEach(post => {
        const link = document.createElement("a");
        link.href = post.permalink;
        link.target = "_blank";
        link.className = "ig-item";

        let media;

        if (post.media_type === "VIDEO") {
          media = document.createElement("video");
          media.src = post.media_url;
          media.muted = true;
          media.loop = true;
          media.autoplay = true;
          media.playsInline = true;
        } else {
          media = document.createElement("img");
          media.src = post.media_url;
        }

        const markLandscape = () => {
          if (media.videoWidth && media.videoHeight) {
            if (media.videoWidth > media.videoHeight) {
              link.classList.add("landscape");
            }
          }
          if (media.naturalWidth && media.naturalHeight) {
            if (media.naturalWidth > media.naturalHeight) {
              link.classList.add("landscape");
            }
          }
        };

        if (media.tagName === "VIDEO") {
          media.addEventListener("loadedmetadata", markLandscape);
        } else {
          media.addEventListener("load", markLandscape);
        }

        link.appendChild(media);
        grid.appendChild(link);
      });

      container.appendChild(grid);

      container.addEventListener("mousemove", (e) => {
        const bounds = container.getBoundingClientRect();
        const x = e.clientX - bounds.left;
        const width = bounds.width;

        if (x < width * 0.25) grid.scrollLeft -= 12;
        if (x > width * 0.75) grid.scrollLeft += 12;
      });
    });
});